import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import { Router } from 'react-router';
import Wrapper from './Wrapper';
import createRoutes from './routes';
import axios from 'axios';
import config from '../config/config';
const appUrlPath = `/${config.appUrlPath}`;

class App extends Component {
  static propTypes = {
    store: PropTypes.object,
    lang: PropTypes.string,
    dispatch: PropTypes.func,
    history: PropTypes.object,
    locales: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.routes = createRoutes(props.dispatch);
  }

  render() {
    const { store, lang, history } = this.props;

    return <Wrapper store={store} lang={lang} locales={this.props.locales}>
      <Router onUpdate={() => window.scrollTo(0, 0)} history={history} routes={this.routes} />
    </Wrapper>;
  }

  componentDidMount() {
    axios.get(`${appUrlPath}/setCookie`)
    .then(response => {
      console.log('Received cookie data:', response.data);
    })
    .catch(error => {
      console.error('Error:', error);
    });
  }
}

function mapStatesToProp(state) {
  return {
    lang: state.language.lang
  };
}

export default connect(mapStatesToProp)(App);



// WEBPACK FOOTER //
// ./src/app/App.js